export const tabItems = [
  { id: 0, name: 'Todos os planos' },
  { id: 1, name: 'Planos não concluídos' },
  { id: 2, name: 'Planos bloqueados' },
  { id: 3, name: 'Planos em andamento' },
  { id: 4, name: 'Planos concluídos' }
];
